
export * from './brave-blocker';
export * from './filter-updater';
export * from './singleton';

// Export individual protection modules for advanced usage
export { injectScriptlets } from './scriptlets';
export { injectCosmeticFiltering } from './cosmetic';
export { injectRedirectBlocking } from './redirects';
export { injectStealth } from './stealth';
export { injectVideoAdBlocking } from './video-ads';
export { injectNativeAdBlocking } from './native-ads';
export { setupEarlyInjection, EARLY_AD_CSS } from './cdp-early-injection';

// Default singleton exports for easy access
export {
    getBraveBlockerSingleton,
    initBraveBlockerSingleton,
    isBraveBlockerInitialized,
    resetBraveBlockerSingleton,
    getBraveBlockerInfo
} from './singleton';


